'use client';

import { usePathname } from 'next/navigation';

/** Resolve dynamic segment ID from pathname for static-export hosting rewrites. */
export function useRouteId(segment: string, fallback?: string): string {
  const pathname = usePathname() ?? '';
  const parts = pathname.split('/').filter(Boolean);
  const idx = parts.indexOf(segment);
  if (idx >= 0 && parts[idx + 1]) {
    return parts[idx + 1];
  }
  return fallback ?? '';
}
